export const SARVAH_EMAIL = "sarvahcampaign@manipalcigna.com";
